import React, { useRef, useState } from 'react';
import Lottie from 'lottie-react';

import animationData from '@atom/components/common/svgIcons/aiChatbotAnimatedButton.json';
import { IconButton } from '@atom/mui';

import AIChatbotDrawer from './aiDrawer/AIChatbotDrawer';

import './askAIButton.css';

const styles = {
  askButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    margin: '0 0.5rem 0 0',
    padding: '0.25rem 0.5rem 0.25rem 0.25rem',
    borderRadius: '32px',
  },
  lottieIcon: {
    height: '32px',
    width: '32px',
  },
};

const AskAIButton = () => {
  const lottieRef = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleMouseEnter = () => {
    if (lottieRef.current) {
      lottieRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(0, true);
    }
  };

  return (
    <div styleName="ask-ai-button-container">
      <IconButton
        onClick={() => setIsDrawerOpen(true)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        size="small"
        style={styles.askButton}
      >
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop
          autoplay={false}
          style={styles.lottieIcon}
        />
        <span styleName="ask-ai-text">Ask AI</span>
      </IconButton>
      {isDrawerOpen && (
        <AIChatbotDrawer onClose={() => setIsDrawerOpen(false)} />
      )}
    </div>
  );
};

export default AskAIButton;
